import * as React from "react";
import { styled } from "@mui/material";

//region [[ Styles ]]

const ThreeDotsLoaderView = styled("div")(({ theme }) => ({
  display: "inline-flex",
  justifyContent: "start",
  gap: 5,
  marginTop: 10,
  "&.small-loader": {
    transform: "scale(0.6)",
    marginLeft: -5,
  },
  "& .single-dot": {
    left: "-15px",
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.primary.main,
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out",
    animationName: "pulse",
    animationDuration: "340ms",
  },

  "& .pulse2": {
    animationDelay: "100ms",
  },
  "& .pulse3": {
    animationDelay: "200ms",
  },
  "@keyframes pulse": {
    from: { opacity: 1, transform: "translateY(-5px)" },
    to: { opacity: 0 },
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ThreeDotsLoaderProps {
  small?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ThreeDotsLoader = ({ ...props }: ThreeDotsLoaderProps) => {
  return (
    <ThreeDotsLoaderView className={props.small ? "small-loader" : ""}>
      <div className="single-dot pulse1" />
      <div className="single-dot pulse2" />
      <div className="single-dot pulse3" />
    </ThreeDotsLoaderView>
  );
};
